import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ParticipantFormData } from "../../types";
import { InputDatePicker } from "../../../../../components/InputDatePicker";

interface ParticipantOrganizationalForm {
    formData: ParticipantFormData;
    onChangeInputField: (field: keyof ParticipantFormData) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
    onChangeDataField: (field: keyof ParticipantFormData) => (date: Date | null) => void;
}

export default function ParticipantOrganizationalForm({ formData, onChangeInputField, onChangeDataField }: ParticipantOrganizationalForm) {
    const { t } = useTranslation();

    return (
        <>
            <Row style={{ marginTop: '40px' }}>
                <h5>{t("participant:new.headerOperationalData")}</h5>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col xs={4} md={4}>
                    <InputDatePicker
                        value={formData.actDateISO}
                        onChange={onChangeDataField('actDateISO')}
                        label={t("participant:new.labelDateAct")}
                    />

                </Col>
                <Col xs={6} md={4}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelCodeAct")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.codeAct}
                            value={formData.codeAct}
                            onChange={onChangeInputField('codeAct')}
                        />
                    </Form.Group>
                </Col>
                <Col xs={4} md={4}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelAct")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.act}
                            value={formData.act}
                            onChange={onChangeInputField('act')}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelCodeCenter")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.codeCenter}
                            value={formData.codeCenter}
                            onChange={onChangeInputField('codeCenter')}
                        />
                    </Form.Group>
                </Col>
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelNameCenter")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.nameCenter}
                            value={formData.nameCenter}
                            onChange={onChangeInputField('nameCenter')}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelCodeService")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.codeService}
                            value={formData.codeService}
                            onChange={onChangeInputField('codeService')}

                        />
                    </Form.Group>
                </Col>
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelServiceName")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.nameService}
                            value={formData.nameService}
                            onChange={onChangeInputField('nameService')}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelCodeUnit")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.codeUnit}
                            value={formData.codeUnit}
                            onChange={onChangeInputField('codeUnit')}
                        />
                    </Form.Group>
                </Col>
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelNameUnit")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.nameUnit}
                            value={formData.nameUnit}
                            onChange={onChangeInputField('nameUnit')}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row style={{ marginTop: '30px' }}>
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelLocation")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.location}
                            value={formData.location}
                            onChange={onChangeInputField('location')}
                        />
                    </Form.Group>
                </Col>
                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>{t("participant:new.labelBuilding")}</Form.Label>
                        <Form.Control
                            type="text"
                            name={formData.building}
                            value={formData.building}
                            onChange={onChangeInputField('building')}

                        />
                    </Form.Group>
                </Col>
            </Row>
        </>
    );
}